import { MaterialesEffects } from "./materiales.effects";
import { FiltersEffects } from "./filters.effects";

export const EFFECTS: any[] = [
  MaterialesEffects,
  FiltersEffects
]
